var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #313131;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-black",
    transform: "translate(-826 359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(826 -359)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-home",
    "data-name": "Icon feather-home",
    transform: "translate(818.717 -367.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-2",
    d: "M107.283,8.167a7.822,7.822,0,0,1,4.81,1.65l82.949,64.516a7.834,7.834,0,0,1,3.024,6.184V181.9A26.3,26.3,0,0,1,171.8,208.167H42.767A26.3,26.3,0,0,1,16.5,181.9V80.517a7.834,7.834,0,0,1,3.024-6.184L102.474,9.817A7.822,7.822,0,0,1,107.283,8.167ZM182.4,84.348,107.283,25.925,32.168,84.348V181.9a10.611,10.611,0,0,0,10.6,10.6H171.8a10.611,10.611,0,0,0,10.6-10.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-2",
    d: "M129.634,199.334A7.834,7.834,0,0,1,121.8,191.5V107.168H82.168V191.5a7.834,7.834,0,1,1-15.668,0V99.334A7.834,7.834,0,0,1,74.334,91.5h55.3a7.834,7.834,0,0,1,7.834,7.834V191.5A7.834,7.834,0,0,1,129.634,199.334Z",
    transform: "translate(5.3 8.833)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlack);
export default __webpack_public_path__ + "static/media/home-black.ced6e51b987835b800c94a3c98b6052e.svg";
export { ForwardRef as ReactComponent };